import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";

import StoryExperience from "@/components/StoryExperience";
import { listExperiences } from "@/lib/experiences.functions";

export function ExperienceDeepLink({ slug }: { slug: string }) {
  const fetchExps = useServerFn(listExperiences);
  const { data: experiences } = useQuery({
    queryKey: ["experiences"],
    queryFn: () => fetchExps(),
    staleTime: 60_000,
  });

  if (!experiences) {
    return <div className="fixed inset-0 bg-background" />;
  }

  const match = experiences.find((e) => e.slug === slug && e.include_in_picker);

  if (match && typeof window !== "undefined") {
    try {
      localStorage.setItem("backland.experience", match.slug);
    } catch {
      // ignore
    }
  }

  if (!match) {
    return (
      <StoryExperience
        chooserError={`"${slug}" isn't a valid experience. Please choose one below.`}
      />
    );
  }
  return <StoryExperience />;
}
